import React from 'react';
import { NavLink } from 'react-router-dom';
import api from './../../utils/api';
import { toast } from 'react-toastify';

import { Button } from '../common';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  pinboardOverlay,
  submitFeedbackOverlay,
  howItWorksOverlay,
} from '../../redux/actions';
import {gaTrackDownload} from '../../utils/helper';

const downloadFullDataSet = () => {
  return api
    .post('/export/fullDataset', {}, {
      responseType: 'blob',
    })
    .then((response) => {
      // Create a Blob from the response data
      const file = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      // Generate a URL for the Blob
      const fileURL = URL.createObjectURL(file);

      // Create a temporary anchor element to trigger the download
      const link = document.createElement('a');
      link.href = fileURL;
      link.setAttribute('download', 'Excel_Export_Full_Dataset.xlsx');

      // Append the anchor to the body
      document.body.appendChild(link);

      // Trigger the download by simulating a click
      link.click();

      // Clean up by removing the anchor and revoking the object URL
      document.body.removeChild(link);
      URL.revokeObjectURL(fileURL);

      gaTrackDownload('excel_full_dataset');
    })
    .catch((err) => {
      console.error('Error downloading the file', err);
      toast.error('Error downloading the file');
    });
};

const Page = (props) => {
  const { process, property, stage } = props.pinboard;
  let totalPinned = 0;
  totalPinned = process.length + property.length + stage.length;

  return (
    <div className="col-xs-12 page-wrapper">
      <header>
        <div className="how" onClick={() => props.howItWorksOverlay(true)}>
          How does this work?
        </div>
        <div>
          <nav className="nav-left pull-left">
            <ul>
              <li>
                <NavLink exact={true} activeClassName="is-active" to="/">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink activeClassName="is-active" to="/about">
                  About
                </NavLink>
              </li>
            </ul>
          </nav>

          <nav className="nav-right pull-right">
            <ul>
              <li>
                <a onClick={() => props.submitFeedbackOverlay(true)}>
                  Submit feedback
                </a>
              </li>
              <li>
                <Button
                  classes="clear iconized download-full-dataset plain"
                  //onClick={() => this.exportAllPDF()}
                  onClick={() => downloadFullDataSet()}>
                  Download full dataset
                </Button>
              </li>
              <li className="pinboard-btn">
                <a
                  className="pinboard"
                  onClick={() => props.pinboardOverlay(true)}>
                  My Pinboard ({totalPinned})
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </header>
      {props.children}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { pinboard } = state.pinboard;
  return { pinboard };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      pinboardOverlay,
      submitFeedbackOverlay,
      howItWorksOverlay,
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Page);
